/** Locale codes stored in `tbl_user.language` for app UI (matches `locales/` folders).
 * `label` is the language's own name so users can find it whatever the UI is in.
 * Keep in step with ALLOWED_UI_LANGUAGES in backend/constant/global.constant.js. */
export const UI_LOCALE_OPTIONS = [
  { code: "en", label: "English" },
  { code: "hi", label: "हिन्दी" },
  { code: "mr", label: "मराठी" },
];

const SUPPORTED_CODES = UI_LOCALE_OPTIONS.map((o) => o.code);
const NAME_TO_CODE = { english: "en", hindi: "hi", marathi: "mr" };

/**
 * Map DB / legacy values to a supported UI locale code.
 */
export function normalizeUserUiLanguage(stored) {
  if (!stored) return "en";
  const s = String(stored).trim().toLowerCase();
  if (SUPPORTED_CODES.includes(s)) return s;
  return NAME_TO_CODE[s] || "en";
}
